module.exports = __webpack_public_path__ + "house_and_building.bdb51fb3520a68cea9705847edb51d51.png";